/** APIから届くタグ名のUnicode表記揺れを正規化してR18か判定する。 */
export function isR18ThreadTagName(value: string): boolean {
  return value.normalize("NFKC").trim().toLocaleUpperCase("en-US") === "R18";
}
